var exports = {
  "h": "skeletonText__b-oFfQ",
};

module.exports = exports;
